module.exports = __webpack_public_path__ + "static/media/google.cdea44bd.svg";